import React, { useEffect } from 'react'
import { Box, Container, Grid, Typography } from '@mui/material';
import Buypop from '../Buymodal/Buypop';
import { Link } from 'react-router-dom';
import CheckBoxIcon from '@mui/icons-material/CheckBox'; 
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary'; 
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; 
import { API_URL, APP_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid, Notarizebscaddress, NotarizeETHaddress, Notarizematicaddress } from '../../Config';
import { useState } from 'react';
import axios from 'axios';
import LikeButton from '../Like/likebutton';
import bnb from '../../images/bnb.png'
import eth from '../../images/eth.png'
import matic from '../../images/matic.png'

const Buyleft = (props) => {
  const [expanded, setExpanded] = React.useState(false);
  const [propdata,setpropdata]=useState([]);
  const [leveldata,setleveldata]=useState([]);
  const [statedata,setstatedata]=useState([]);
  const [nftinfo, setnftinfo]=useState([]);
  let data =props.buyprop?.data?.NFT_info;

  const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
  };

  const fetchbuydata=async()=>{
    // fetch property
    await axios.get(`${API_URL}/Buyitem.php?type=property&id=${props.buyprop?.data?.NFT_info?.NFT_id}`,{
        headers:{
            "Content-Type":"application/json",
        },

     }).then((res)=>{ 
            if(res.data){
              setpropdata(res.data);
            }else{
              setpropdata([]);
            }
        })

    // Fetch state
   
    await axios.get(`${API_URL}/Buyitem.php?type=state&id=${props.buyprop?.data?.NFT_info?.NFT_id}`,{
        headers:{
            "Content-Type":"application/json",
        },

    }).then((res)=>{
      
            if(res.data){
              setstatedata(res.data);
            }else{
              setstatedata([]);
            }
        })
    // Fetch level
    await axios.get(`${API_URL}/Buyitem.php?type=level&id=${props.buyprop?.data?.NFT_info?.NFT_id}`,{
      headers:{
          "Content-Type":"application/json",
      },

    }).then((res)=>{
            if(res.data){
              setleveldata(res.data);
            }else{
              setleveldata([]);
            }
      }) 

   }

  const fetchnftinfo=async()=>{
      await axios.get(`${API_URL}/Buyitem.php?type=GetNftInfo&id=${props.buyprop?.data?.NFT_info?.NFT_id}`,{
          headers:{
              "Content-Type":"application/json",
          },
  
       }).then((res)=>{
              
              if(res.data){
                  setnftinfo(res.data);
              }else{
                  setnftinfo([]);
              }
          })
      }
  useEffect(()=>{
    fetchnftinfo();
    fetchbuydata();
  },[props.buyprop?.data])

  return (
    <>
      <Box className='Collection_auction'>
        <Container maxWidth='lg' >
          <Grid container spacing={2}>
              <Grid  item xs={12} md={12 }>
                <Box className='mainsboxs' paddingTop='15px'>
                  <Typography variant='h3' gutterBottom component='div' fontWeight='500' fontSize='18px' >
                    <Link to={`/CollectionDetails/${props.buyprop?.data?.Collection_info?.collection_name}`}>Arts of the {props.buyprop?.data?.NFT_info?.NFT_collection} </Link>
                  </Typography>
                  <Box className='innerimg'>
                    <Box display='flex' justifyContent='space-between'>
                      <Typography variant='h2' gutterBottom component='div' fontWeight='bold' fontSize='28px' >
                      {props.buyprop?.data?.NFT_info?.Private==0?props.buyprop?.data?.NFT_info?.NFT_name:"SECRET NFT"}
                      </Typography>
                      {nftinfo && nftinfo.map((token, index) => (
                          <LikeButton key={index} nft={token} /> 
                      ))}
                  
                    </Box>
                    <Typography variant='h5' gutterBottom component='div' fontWeight='bold' fontSize='16px' >
                      NFT ID:  {props.buyprop?.data?.NFT_info?.NFT_id}
                    </Typography>
                    <Typography variant='h5' gutterBottom component='div' fontWeight='bold' fontSize='16px' >
                      Category: {props.buyprop?.data?.NFT_info?.NFT_category}
                    </Typography>
                  </Box>

                  {/* <Box>
                    <Timer />
                  </Box> */}
                  <Grid container spacing={2} marginY='15px'>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                      <Typography variant='h6' gutterBottom component='div' fontWeight='500' fontSize='18px'>
                        Created By
                      </Typography>
                      <Box display='' alignItems='center' justifyContent='' className='doubal'>
                        <Box className='nameuser'>
                        <Link to={`/Profile/${props.buyprop?.data?.Creator_info?.Useraddress}`}> <img src={APP_URL+'/'+props.buyprop?.data?.Creator_info?.Userimage} width='100px' alt=''/>
                          </Link>
                          <CheckBoxIcon />
                        </Box>
                        <Box className='cretors'>
                          <Typography variant='h4' gutterBottom component='div' fontWeight='Bold' fontSize='16px'>
                          <Link to={`/Profile/${props.buyprop?.data?.Creator_info?.Useraddress}`}>  {props.buyprop?.data?.Creator_info?.Username}</Link>
                          </Typography>

                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={6} sm={6} md={6} xs={12}>
                      <Typography variant='h6' gutterBottom component='div' fontWeight='500' fontSize='18px'>
                        Collection
                      </Typography>
                      <Box display='' alignItems='center' justifyContent='' className='doubal'>
                        <Box className='nameuser'>
                          <Link to={`/CollectionDetails/${props.buyprop?.data?.Collection_info?.collection_name}`}><img src={APP_URL+'/'+ props.buyprop?.data?.Collection_info?.collection_logo} width='100px' alt='' /></Link>
                          <CheckBoxIcon />
                        </Box>
                        <Box className='cretors'>
                          <Typography variant='h4' gutterBottom component='div' fontWeight='Bold' fontSize='16px'>
                          <Link to={`/CollectionDetails/${props.buyprop?.data?.Collection_info?.collection_name}`}> {props.buyprop?.data?.Collection_info?.collection_name}</Link>
                          </Typography>

                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                  <hr></hr> 
                <Box>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} className='accor_one'>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header" className='accor_head'>
                    <Typography fontSize='17px' fontWeight='600'>
                        Price History
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box className='kajol' display={'flex'} borderRadius={'5px'} border={{ padding: '10px', fontWeight: 'bold' }}>
                        <Box className='ramkalyan' >
                        {props.buyprop?.data?.NFT_info?.NFT_chainid == Bsc_Chainid ? 
                            <img src={bnb} width={'40px'} />
                            :props.buyprop?.data?.NFT_info?.NFT_chainid == Matic_Chainid ? 
                            <img src={matic} width={'40px'} />
                            :props.buyprop?.data?.NFT_info?.NFT_chainid == ETH_Chainid ?       
                            <img src={eth} width={'40px'} />:""}
                            <Typography variant='h5' fontSize='20px' display={'inline-block'} marginLeft={'15px'} fontWeight='bold' textAlign='center' >
                            {props.buyprop?.data?.NFT_info?.NFT_price} {props.buyprop?.data?.NFT_info?.NFT_payment} 
                            </Typography>
                        </Box>
                    </Box>
                </AccordionDetails>
            </Accordion>
            {props.buyprop?.data?.NFT_info?.Membernft=="1" ? 
            
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} className='accor_one' >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content" id="panel2bh-header" className='accor_head'>
                    <Typography fontSize='17px' fontWeight='600'> Reward Tokens</Typography>
                </AccordionSummary>
                <AccordionDetails style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between'}}>
                    {/* <Typography variant='h4' fontSize='20px' fontWeight='600'> By:- A79CE8</Typography> */}
                    <Typography variant='h6' fontSize='18px' fontWeight='400' >
                    {props.buyprop?.data?.NFT_info?.Tokens}  {props.buyprop?.data?.NFT_info?.TokenName} 
                    </Typography>
                    <Typography variant='h6' fontSize='18px' fontWeight='400' >
                    <a target='blank' href={props.buyprop?.data?.NFT_info?.NFT_chainid==Bsc_Chainid?`https://testnet.bscscan.com/token/${bsccontractaddress}?a=${props.buyprop?.data?.NFT_info?.NFT_id}`
                      :props.buyprop?.data?.NFT_info?.NFT_chainid==Matic_Chainid?`https://mumbai.polygonscan.com/token/${maticcontractaddress}?a=${props.buyprop?.data?.NFT_info?.NFT_id}`:props.buyprop?.data?.NFT_info?.NFT_chainid==ETH_Chainid?`https://goerli.etherscan.io/token/${ethcontractaddress}?a=${props.buyprop?.data?.NFT_info?.NFT_id}`:''}>
                      <span>{props.buyprop?.data?.NFT_info?.NFT_chainid==Bsc_Chainid?bsccontractaddress:props.buyprop?.data?.NFT_info?.NFT_chainid==Matic_Chainid?maticcontractaddress:props.buyprop?.data?.NFT_info?.NFT_chainid==ETH_Chainid?ethcontractaddress:''}</span>
                    </a>
                    </Typography>

                </AccordionDetails>
            </Accordion>:''}
            <Accordion expanded={expanded === 'panel20'} onChange={handleChange('panel20')} className='accor_one'>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content" id="panel2bh-header" className='accor_head'>
                    <Typography fontSize='17px' fontWeight='600'> Descriptions</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {/* <Typography variant='h4' fontSize='20px' fontWeight='600'> By:- A79CE8</Typography> */}
                    <Typography variant='h6' fontSize='15px' fontWeight='400' paddingTop='10px'>
                    {props.buyprop?.data?.NFT_info?.NFT_discription}
                    </Typography>

                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')} className='accor_one'>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3bh-content" id="panel3bh-header" className='accor_head'>
                    <Typography fontSize='17px' fontWeight='600'>
                        Properties
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2}>
                      {propdata && propdata.map((prop,idx)=>(
                        <Grid key={idx} item xs={6} md={6}>
                          <Box className='trait'>
                              <Typography variant='h3' fontSize='20px' fontWeight='600'>  {prop.NFT_property} </Typography>
                              <Typography variant='h5' fontSize='18px' fontWeight='400'> {prop.NFT_type}</Typography>
                          </Box>
                      </Grid>
                      ))}
                       {leveldata && leveldata.map((prop,idx)=>(
                        <Grid key={idx} item xs={6} md={6}>
                          <Box className='trait'>
                              <Typography variant='h3' fontSize='20px' fontWeight='600'>  {prop.NFT_level}</Typography>
                              <Typography variant='h5' fontSize='18px' fontWeight='400'> {prop.value} </Typography>
                          </Box>
                      </Grid>
                      ))}
                       {statedata && statedata.map((prop,idx)=>(
                        <Grid key={idx} item xs={6} md={6}>
                          <Box className='trait'>
                              <Typography variant='h3' fontSize='20px' fontWeight='600'>  {prop.NFT_stat} </Typography>
                              <Typography variant='h5' fontSize='18px' fontWeight='400'> {prop.value}</Typography>
                          </Box>
                      </Grid>
                      ))}

                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')} className='accor_one'>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content" id="panel4bh-header" className='accor_head'>
                    <Typography fontSize='17px' fontWeight='600'> Details </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box className='Contract_add'>
                        <ul>
                        <li>Contract Address <a target='blank' href={data?.NFT_chainid==Bsc_Chainid?`https://testnet.bscscan.com/token/${data?.Notarize==1? Notarizebscaddress:bsccontractaddress}?a=${data?.NFT_id}`
                        :data?.NFT_chainid==Matic_Chainid?`https://mumbai.polygonscan.com/token/${data?.Notarize==1? Notarizematicaddress:maticcontractaddress}?a=${data?.NFT_id}`:data?.NFT_chainid==ETH_Chainid?`https://goerli.etherscan.io/token/${
                        data?.Notarize==1? NotarizeETHaddress:ethcontractaddress}?a=${data?.NFT_id}`:''}>
                        <span>{data?.NFT_chainid==Bsc_Chainid?
                        data?.Notarize==1?Notarizebscaddress: bsccontractaddress
                        :data?.NFT_chainid==Matic_Chainid?data?.Notarize==1?Notarizematicaddress
                        :maticcontractaddress:data?.NFT_chainid==ETH_Chainid?data?.Notarize==1?NotarizeETHaddress:ethcontractaddress:''}</span></a> </li>
                        <li>Token ID <span>{data?.NFT_id} </span></li>
                        <li>Token Standard <span>ERC-721</span></li>
                        <li>Chain <span>{data?.NFT_chainid==Bsc_Chainid?"BINANCE":data?.NFT_chainid==Matic_Chainid?"MATIC":data?.NFT_chainid==ETH_Chainid?"Ethereum":""}</span></li>
    
                        </ul>
                    </Box>
                </AccordionDetails>
              </Accordion>
                </Box>

                  <Box className='placebid'>
                    <Buypop prop={props.buyprop}/>
                  </Box>
                  {/* <Typography variant='body2' paddingY={3} gutterBottom component='div' fontWeight='normal' fontSize='20px' >
                    {nftsection.buyhis}
                  </Typography> */}

                </Box>
              </Grid>
         
          </Grid>
        </Container>

      </Box>
    </>
  )
}

export default Buyleft;